<template>
  <div>
    <div
      id="loading-grid"
      v-if="!loaded"
      style="margin: 10% 40%; position: absolute; z-index: 231"
    >
      <svg
        class="spinner"
        width="65px"
        height="65px"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class="path"
          fill="none"
          stroke-width="6"
          stroke-linecap="round"
          cx="33"
          cy="33"
          r="30"
        ></circle>
      </svg>
    </div>
    <div id="cat" v-cloak :class="{ showhide: !loaded }">
      <div class="vx-card mb-4">
        <div class="vx-card__collapsible-content vs-con-loading__container">
          <div class="vx-card__body card-body">
            <div class="vx-row">
              <div class="w-full px-4 flex gap-4 flex-wrap">
                <router-link
                  :to="{ path: '/ActualProduct/Create' }"
                  class="vs-component vs-button bg_l_green sm:flex-grow-0 flex-grow text-center"
                  v-has-permission="permission192"
                >
                  <feather-icon
                    icon="PlusIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />{{ $t("CreateNewProduct") }}
                </router-link>
                <div class="flex flex-grow justify-end gap-4">
                  <div class="flex">
                    <label class="custom-file-upload">
                      <input
                        type="file"
                        id="file"
                        ref="file"
                        v-on:change="handleFileUpload()"
                      />

                      <feather-icon
                        icon="PaperclipIcon"
                        svgClasses="h-4 w-4"
                        class="ico"
                      />
                      {{ $t("ChooseFile") }}
                      <span v-if="uploadedFileName" class="file-name">{{
                        uploadedFileName
                      }}</span>
                    </label>
                    <vs-button
                      @click="uploadFile()"
                      class="bg_m_green float-right"
                      v-if="fileUploaded"
                      :disabled="disabledBtn"
                      v-has-permission="permission195"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        svgClasses="h-4 w-4"
                        class="ico"
                      />
                      {{ $t("UploadFile") }}
                    </vs-button>
                  </div>
                  <vs-button
                    @click="downloadFile()"
                    class="bg_purple float-right"
                    v-has-permission="permission191"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      svgClasses="h-4 w-4"
                      class="ico"
                    />
                    {{ $t("DownloadExcelFile") }}
                  </vs-button>
                  <div class="flex">
                    <div class="w-full">
                      <vs-button
                        @click="showFilters = !showFilters"
                        class="bg_purple float-right"
                      >
                        <div class="px-3">
                          <feather-icon
                            icon="FilterIcon"
                            svgClasses="h-4 w-4"
                            class="ico"
                          />
                          {{ $t("Filter") }}
                        </div>
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row" v-if="showFilters">
              <div class="w-full px-4">
                <form>
                  <div class="flex flex-wrap pt-2 gap-y-2">
                    <div class="lg:w-3/4 sm:w-2/3 w-full sm:pl-4">
                      <vs-input
                        class="inputx"
                        v-model="gridSearchData.name"
                        :label="$t('ProductName')"
                      />
                    </div>
                    <div class="lg:w-1/4 sm:w-1/3 w-full">
                      <label class="vs-input--label">{{ $t("Status") }}</label>
                      <div class="w-full">
                        <v-select
                          label="name"
                          name="Status"
                          :options="Status"
                          v-model="gridSearchData.Status"
                          :reduce="(x) => x.id"
                          dir="rtl"
                        >
                        </v-select>
                      </div>
                    </div>
                    <div class="mt-4 w-full">
                      <div class="vx-col w-full">
                        <vs-button
                          type="filled"
                          class="float-right"
                          @click.prevent="submitFilter()"
                          >{{ $t("SubmitFilter") }}</vs-button
                        >
                        <vs-button
                          type="filled"
                          class="float-right ml-4"
                          id="reset-btn"
                          @click.prevent="resetForm"
                          >{{ $t("ResetFilter") }}</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="vx-row pt-4">
              <div class="vx-col w-full mb-base">
                <data-grid
                  ref="grid"
                  stripe
                  :data-source="gridDataSource"
                  :search-data="gridSearchData"
                  :columns="[
                    { title: $t('PersianName'), sort: 'PersianName' },
                    { title: $t('EnglishName'), sort: 'EnglishName' },
                    { title: $t('ItemCode'), sort: 'ItemCode' },
                    { title: $t('GenericProduct'), sort: 'GenericProduct' },
                    { title: $t('Status'), sort: 'Status' },
                    { title: $t('CreateOn'), sort: 'CreateOn' },
                    { title: $t('Action') },
                  ]"
                >
                  <template slot-scope="{ row }">
                    <td style="width: 20%">
                      {{ row.persianName }}
                    </td>
                    <td style="width: 20%">
                      {{ row.name }}
                    </td>
                    <td style="width: 10%">
                      {{ row.id }}
                    </td>
                    <td style="width: 10%">
                      {{ row.genericProduct.name }}
                    </td>
                    <td style="width: 10%">
                      <span v-if="row.status == 1">
                        {{ $t("Draft") }}
                      </span>
                      <span v-if="row.status == 2">
                        {{ $t("Review") }}
                      </span>
                      <span v-if="row.status == 3">
                        {{ $t("Publish") }}
                      </span>
                    </td>
                    <td style="width: 12%; direction: ltr">
                      {{ row.createOn.split(" ")[0] }}<br />{{
                        row.createOn.split(" ")[1]
                      }}
                    </td>
                    <td style="width: 10%">
                      <router-link
                        :to="{ path: '/ActualProduct/edit/' + row.id }"
                      >
                        <vs-button
                          radius
                          color="success"
                          size="small"
                          type="gradient"
                          icon-pack="feather"
                          icon="icon-edit"
                          class="ml-4 d-inline"
                          v-has-permission="permission193"
                        ></vs-button>
                      </router-link>
                      <vs-button
                        radius
                        color="danger"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-x"
                        @click.prevent="deleteProduct(row.id)"
                        class="d-inline"
                        v-has-permission="permission194"
                      ></vs-button>
                    </td>
                  </template>
                </data-grid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.showhide {
  opacity: 0.5;
  z-index: 1;
}
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}

#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";

export default {
  components: {
    DataGrid,
    "v-select": vSelect,
  },
  data() {
    return {
      permission191: "GetAllActualProductsExcelFile",
      permission192: "CreateActualProduct",
      permission193:
        "GetActualProductbyId|ModifyActualProduct|ModifyProductAttribute|GetPictureByActualProduct|AttachFileActualProduct|UnAttachFileActualProduct|ModifyPictureActualProduct|GetVideoByActualProduct|AttachFileActualProduct|UnAttachFileActualProduct",
      permission194: "DeleteActualProduct",
      permission195: "CreateActualProductByExcelFile",
      showFilters: false,
      loaded: true,
      gridDataSource: {
        type: "app",
        service: "ProductManagement/api/ActualProductsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
      file: "",
      fileUploaded: false,
      disabledBtn: false,
      updateLoading: false,
      uploadedFileName: "",
      Status: [
        { name: "پیش نویس", id: 1 },
        { name: "بازبینی", id: 2 },
        { name: "انتشار", id: 3 },
      ],
    };
  },
  methods: {
    ...mapActions({
      importActualProducts: "excel/importActualProducts",
      exportActualProducts: "excel/exportActualProducts",
      removeActualProduct: "actualProduct/remove",
    }),
    downloadFile() {
      this.loaded = false;
      this.exportActualProducts().then(() => {
        setTimeout(() => {
          this.loaded = true;
        }, 0);
      });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    uploadFile() {
      this.loaded = false;
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);

      this.importActualProducts(formData)
        .then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "فایل مورد نظر با موفقیت بارگذاری شد!",
            showConfirmButton: false,
            timer: 5000,
          });
          this.disabledBtn = false;
          this.updateLoading = true;
          setTimeout(() => {
            this.$refs.grid.renderGrid();
            this.updateLoading = false;
            this.uploadedFileName = "";
          }, 5000);
          setTimeout(() => {
            this.loaded = true;
          }, 0);
        })
        .catch(() => {
          this.disabledBtn = false;
          setTimeout(() => {
            this.loaded = true;
          }, 0);
        });
    },
    deleteProduct(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeActualProduct(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        name: "",
        Status: "",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
